import { render, staticRenderFns } from "./CPageContactConfirmStandard.vue?vue&type=template&id=28488b8e&"
import script from "./CPageContactConfirmStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageContactConfirmStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports